import { InmateProgressContainer, ProgressBar, ProgressBarItem } from "./styles";

export const INMATE_PROGRESS_MODE = {
  INTAKE_PENDING: { key: "INTAKE_PENDING", text: "INTAKE_PENDING", step: 0 },
  INTAKE_IN_PROGRESS: { key: "INTAKE_IN_PROGRESS", text: "INTAKE_IN_PROGRESS", step: 1 },
  INTAKE_DONE: { key: "INTAKE_DONE", text: "INTAKE_DONE", step: 2 },
  BOOKING_PENDING: { key: "BOOKING_PENDING", text: "BOOKING_PENDING", step: 3 },
  BOOKING_IN_PROGRESS: { key: "BOOKING_IN_PROGRESS", text: "BOOKING_IN_PROGRESS", step: 4 },
  BOOKING_DONE: { key: "BOOKING_DONE", text: "BOOKING_DONE", step: 5 },
  HOUSING_ASSIGNMENT_PENDING: { key: "HOUSING_ASSIGNMENT_PENDING", text: "HOUSING_ASSIGNMENT_PENDING", step: 6 },
  HOUSING_ASSIGNMENT_IN_PROGRESS: {
    key: "HOUSING_ASSIGNMENT_IN_PROGRESS",
    text: "HOUSING_ASSIGNMENT_IN_PROGRESS",
    step: 7,
  },
  HOUSING_ASSIGNMENT_DONE: { key: "HOUSING_ASSIGNMENT_DONE", text: "HOUSING_ASSIGNMENT_DONE", step: 8 },
  MEDICAL_ASSESSMENT_PENDING: { key: "MEDICAL_ASSESSMENT_PENDING", text: "MEDICAL_ASSESSMENT_PENDING", step: 9 },
  MEDICAL_ASSESSMENT_IN_PROGRESS: {
    key: "MEDICAL_ASSESSMENT_IN_PROGRESS",
    text: "MEDICAL_ASSESSMENT_IN_PROGRESS",
    step: 10,
  },
  MEDICAL_ASSESSMENT_DONE: { key: "MEDICAL_ASSESSMENT_DONE", text: "MEDICAL_ASSESSMENT_DONE", step: 11 },
  PROPERTY_DETAILS_PENDING: { key: "PROPERTY_DETAILS_PENDING", text: "PROPERTY_DETAILS_PENDING", step: 12 },
  PROPERTY_DETAILS_IN_PROGRESS: { key: "PROPERTY_DETAILS_IN_PROGRESS", text: "PROPERTY_DETAILS_IN_PROGRESS", step: 13 },
  PROPERTY_DETAILS_DONE: { key: "PROPERTY_DETAILS_DONE", text: "PROPERTY_DETAILS_DONE", step: 14 },
  ALL_DONE: { key: "ALL_DONE", text: "ALL_DONE", step: 15 },
};

export const COLOR_MODE = { DEFAULT: "default", GREEN_ORANGE_ON_BLUE: "goob" };

const InmateProgress = ({ progress, colorMode = COLOR_MODE.DEFAULT }) => {
  return (
    <>
      <InmateProgressContainer>
        In progress-Housing Assignment
        <ProgressBar step={progress?.step} colorMode={colorMode}>
          <ProgressBarItem className="intake" colorMode={colorMode}></ProgressBarItem>
          <ProgressBarItem className="booking" colorMode={colorMode}></ProgressBarItem>
          <ProgressBarItem className="housing-assignment" colorMode={colorMode}></ProgressBarItem>
          <ProgressBarItem className="medical-assessment" colorMode={colorMode}></ProgressBarItem>
          <ProgressBarItem className="property" colorMode={colorMode}></ProgressBarItem>
        </ProgressBar>
      </InmateProgressContainer>
    </>
  );
};

export default InmateProgress;
